import styled from 'styled-components';
const UnreadIcon = styled.div`
  width: 8px;
  height: 8px;
  background: ${({ theme }) => theme.colors.coral};
  border-radius: 15px;
`;
export default UnreadIcon;
